/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Manage_Per_Seat_MoInputs */



/**
* | output |
* | --- |
* | "/seat/mo" |
*
* @param {Partner_Manage_Per_Seat_MoInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_manage_per_seat_mo = /** @type {((inputs?: Partner_Manage_Per_Seat_MoInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Manage_Per_Seat_MoInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("/Platz/Mon.")
	return /** @type {LocalizedString} */ ("/seat/mo")
});